export type TagType = 'featured' | 'hot' | 'new' | 'vip' | 'continue' | 'updated'

export interface TagConfig {
  type: TagType
  label: 'HOT' | 'LATEST' | 'TRENDING' | 'VIP' | 'CONTINUE' | 'UPDATED'
  background: '#8F302C' | '#20242A'
  textColor: string
}

export const TAG_CONFIG_MAP: Record<TagType, TagConfig> = {
  featured: { type: 'featured', label: 'TRENDING', background: '#20242A', textColor: '#E7E4DE' },
  hot: { type: 'hot', label: 'HOT', background: '#8F302C', textColor: '#E7E4DE' },
  new: { type: 'new', label: 'LATEST', background: '#20242A', textColor: '#E7E4DE' },
  vip: { type: 'vip', label: 'VIP', background: '#8F302C', textColor: '#E7E4DE' },
  continue: { type: 'continue', label: 'CONTINUE', background: '#20242A', textColor: '#E7E4DE' },
  updated: { type: 'updated', label: 'UPDATED', background: '#20242A', textColor: '#E7E4DE' },
}

export interface ContentBadgeSignals {
  featuredSwitch?: number | boolean
  hotSwitch?: number | boolean
  newSwitch?: number | boolean
  vipSwitch?: number | boolean
  continueWatching?: boolean
  updated?: boolean
}

export function resolveContentBadge(signals: ContentBadgeSignals): TagConfig | null {
  if (signals.vipSwitch) return TAG_CONFIG_MAP.vip
  if (signals.updated) return TAG_CONFIG_MAP.updated
  if (signals.continueWatching) return TAG_CONFIG_MAP.continue
  if (signals.featuredSwitch) return TAG_CONFIG_MAP.featured
  if (signals.hotSwitch) return TAG_CONFIG_MAP.hot
  if (signals.newSwitch) return TAG_CONFIG_MAP.new
  return null
}
